import { FC } from 'react';
import { Button } from '@livechat/design-system-react-components';

import { CustomLink } from 'components/link/Link';

type Props = {
  onClick?: () => void;
};

export const GoToSignIn: FC<Props> = ({ onClick }) => {
  const onClickWrapper = () => {
    if (onClick != null) {
      onClick();
    }
  };

  return (
    <CustomLink to="/" onClick={onClickWrapper}>
      <Button kind="secondary" size="medium">
        Log in
      </Button>
    </CustomLink>
  );
};
